export const proportionalCategories = [
  {
    id: 1,
    description: 'Very Low',
    earthquake: 0.2,
    hydro: 0.2,
    flood: 0.2,
    other: 0.2,
    o: 0.3,
  },
  {
    id: 2,
    description: 'Low',
    earthquake: 0.4,
    hydro: 0.6,
    flood: 0.3,
    other: 0.3,
    o: 0.4,
  },
  {
    id: 3,
    description: 'Medium',
    earthquake: 0.7,
    hydro: 2.5,
    flood: 0.5,
    other: 0.5,
    o: 0.63,
  },
  {
    id: 4,
    description: 'High',
    earthquake: 1.25,
    hydro: 4.5,
    flood: 0.7,
    other: 0.7,
    o: 3,
  },
  {
    id: 5,
    description: 'Very High',
    earthquake: 1.7,
    hydro: 8,
    flood: 2,
    other: 2,
    o: 4,
  },
];
